import React from "react";
import Navbar from "../../components/registry/Navbar";
import Middle from "../../components/registry/Middle";

function Signup() {
  return (
    <div className="bg-[#F4F6FC] h-[100vh]">
      <Navbar link="Signup" />
      <div className="flex items-center w-full justify-center h-[80vh]">
        <Middle place="signup" />
      </div>
    </div>
  );
}

export default Signup;
